import React from "react";
import QuotationHistory from "./QuotationHistory";

export default function DeletedQuotationHistory() {
  return <QuotationHistory deleted />;
}
